// @flow

// Action Type
import * as actionTypesNavigation from 'store/reducers/navigation/actionTypes';

// Actions
import { gaClickTrackingEvent } from 'store/reducers/ga/actions';

// Constants
import * as routes from 'constants/routes';
import { GA_EVENTS } from 'constants/ga';

// types
import type { Store, Action } from 'types/redux';

export const gaMiddleware = (store: Store) => (
  next: (action: Action) => any
) => (action: any) => {
  switch (action.type) {
    // @GA PAGE TRACKING EVENTS
    case actionTypesNavigation.SET_CURRENT_PATH: {
      if (action.payload === routes.VEHICLE_ROUTE) {
        store.dispatch(gaClickTrackingEvent(GA_EVENTS.VEHICLE));
      }
      if (action.payload === routes.SERVICES_ROUTE) {
        store.dispatch(gaClickTrackingEvent(GA_EVENTS.SERVICES));
      }
      if (action.payload === routes.APPOINTMENT_ROUTE) {
        store.dispatch(gaClickTrackingEvent(GA_EVENTS.TIME));
      }
      if (action.payload === routes.REVIEW_ROUTE) {
        store.dispatch(gaClickTrackingEvent(GA_EVENTS.REVIEW));
      }
      break;
    }
    default:
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/store/middlewares/ga-middleware.js